<template>
  <div>
    <v-card-actions>
      <v-card-title class="text_box">
        <div v-for="role in getProjectRoles" :key="role.id">
          <v-chip color="success" close @click:close="deleteRole(role)">
            {{ role.role_name }}
          </v-chip>
        </div>
      </v-card-title>
    </v-card-actions>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";

export default {
  name: "ProjectRoleView",
  computed: {
    ...mapGetters(["getProjectRoles"]),
  },
  methods: {
    ...mapActions([
      "showLoadingProcess",
      "closeLoading",
      "DeleteProjectRole",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async deleteRole(value) {
      await this.showLoadingProcess();
      try {
        await this.DeleteProjectRole({id: value.id});
        await this.closeLoading();
        await this.showSnackBar({
          text: `${value.role_name} has been deleted from project`,
          color: DEFAULT_CONSTANTS.warn,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        await this.closeLoading();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
  },
};
</script>

<style scoped>
.text_box {
  background-color: whitesmoke;
  padding: 10px;
  text-align: justify;
  border: 3px solid;
  border-radius: 5px;
}
</style>
